<template>
  <div>
    <div>
      <vs-card>
        <div class="d-flex flex-wrap">
          <export :list.sync="students" :config="exportConfig"></export>
          <vs-select key="cohort-select" placeholder="فیلتر بر اساس گروه" class="ml-2" label-placeholder="جستجو کنید"
                     multiple autocomplete v-model="cohortsFilter">
            <vs-select-item :key="`filter-${item.id}`" :value="item.id" :text="item.name" v-for="item in cohorts"/>
          </vs-select>

          <vs-select autocomplete key="lock-select" placeholder="فیلتر بر اساس وضعیت" class="ml-2"
                     label-placeholder="جستجو کنید" v-model="statusFilter">
            <vs-select-item :key="`lock-${item.value}`" :value="item.value" :text="item.name" v-for="item in statuses"/>
          </vs-select>

          <vs-button class="ml-2" v-if="cohortsFilter.length || statusFilter !== ''" type="flat"
                     @click="resetFilter"
                     color="danger">پاک کردن فیلتر
          </vs-button>
        </div>
      </vs-card>

      <div class="show-filters d-flex">
        <vs-chip :key="item.id" size="small" icon="close" class="mr-2 mb-2" color="danger" type="border"
                 @click="removeCohortFilter(item.id)"
                 v-for="item in cohorts.filter(i => cohortsFilter.includes(i.id))" closable>
          {{ item.name }}
        </vs-chip>
      </div>
    </div>
    <div v-if="students.length">
      <vs-table
        search stripe multiple v-model="selected"
        max-items="10" pagination :data="students">
        <template slot="header">
          <div v-if="selected.length && cohorts.length">
            <div class="d-flex flex-wrap align-items-center">
              <b> انتقال <span>{{selected.length}} کاربر</span> به </b>
              <vs-select
                placeholder="جستجوی گروه"
                class="ml-2"
                label-placeholder="جستجو کنید"
                multiple
                autocomplete
                v-model="selectedCohorts">
                <vs-select-item :key="`group-${item.id}`" :value="item.id" :text="item.name" v-for="item in cohorts"/>
              </vs-select>
              <vs-button :disabled="!selectedCohorts.length" color="success" class="move-to-cohorts-btn ml-2"
                         @click="addUsersToCohorts">اعمال
              </vs-button>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>نام و نام خانوادگی</vs-th>
          <vs-th>تلفن همراه</vs-th>
          <vs-th>آدرس</vs-th>
          <vs-th>گروه ها</vs-th>
          <vs-th>عملیات</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].firstName + ' ' + data[indextr].lastName">
              <div class="d-flex align-items-center">
                <div class="avatar">
                  <img height="30" width="30" class="round mr-3 img-fluid"
                       :src="data[indextr].imagePath?data[indextr].imagePath:require('@/assets/images/avatar.png')">
                  <span v-if="getDeviceInfo(tr.deviceId,'status')"
                        :class="`avatar-status-${getDeviceInfo(tr.trackId,'status')}`"></span>
                </div>
                <div>
                  <router-link :to="`/students/edit/${tr.id}`">
                    {{`${tr.firstName} ${tr.lastName}`}}
                  </router-link>
                  <div class="text-muted">{{tr.userName}}</div>
                </div>
              </div>
            </vs-td>
            <vs-td :data="data[indextr].cellPhoneNumber">
              {{tr.cellPhoneNumber}}
            </vs-td>
            <vs-td :data="data[indextr].homeLocationText">
              {{tr.homeLocationText}}
            </vs-td>
            <vs-td :data="data[indextr].groups">
              <div @click.stop="showUserCohorts(tr.id)">
                <button :disabled="!tr.groups.length" class="cohorts-number">
                  {{tr.groups.length}}
                </button>
                <small class="pr-1" v-for="group in tr.groups.slice(0,2)">
                  {{group.name}}
                </small>
                <small class="pr-1" v-if="tr.groups.length>2">و...</small>
              </div>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <feather-icon class="cursor-pointer text-warning" @click.stop="sendMessage(tr)" icon="MailIcon"
                            svgClasses="w-5 h-5"/>
              <router-link :to="`/students/edit/${tr.id}`">
                <feather-icon class="ml-2" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary"/>
              </router-link>
              <feather-icon class="text-danger ml-2 cursor-pointer" icon="TrashIcon" svgClasses="w-5 h-5"
                            @click.stop="deleteStudent(tr.id)"/>
              <feather-icon :class="`ml-2 cursor-pointer ${tr.locked?'text-muted':''}`"
                            :icon="tr.locked?'LockIcon':'UnlockIcon'" svgClasses="w-5 h-5"
                            @click.stop="lockProfile(tr)"/>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <vs-popup title="ارسال پیام به دانش آموز" :active.sync="sendMessageVisible">
      <send-message-form @sent="sendMessageVisible=false"></send-message-form>
    </vs-popup>

    <!-- SHOW USER COHORTS -->
    <vs-popup v-if="activeUser" :title="` گروه های ${activeUser.firstName} ${activeUser.lastName}`"
              :active.sync="userCohortsVisible">
      <div class="user-cohort-card" v-for="cohort in activeUser.groups">
        <div>{{cohort.name}}</div>
        <feather-icon class="text-danger ml-2 cursor-pointer" icon="TrashIcon" svgClasses="w-5 h-5"
                      @click.stop="removeUserFromCohort(activeUser.id,cohort.id)"/>
      </div>
    </vs-popup>
    <!-- SHOW USER TASKS WHEN DELETING USER -->
    <vs-popup v-if="activeUser" :title="` کارگروه های ${activeUser.firstName} ${activeUser.lastName}`"
              :active.sync="userTasksVisible">
      <vs-alert class="my-3">ابتدا باید کارگروه های دانش آموز را حذف کنید</vs-alert>
      <div v-if="activeUserTasks.length" class="user-cohort-card" v-for="task in activeUserTasks">
        <div>{{task.name}}</div>
        <feather-icon class="text-danger ml-2 cursor-pointer" icon="TrashIcon" svgClasses="w-5 h-5"
                      @click.stop="removeUserFromTask(activeUser.id,task.id)"/>
      </div>
    </vs-popup>
  </div>

</template>

<script>

  import SendMessageForm from "../messages/components/SendMessageForm";
  import Export from "../../components/excel/Export";

  export default {
    name: "students",
    components: {Export, SendMessageForm},
    data() {
      return {
        sendMessageVisible: false,
        exportConfig: {
          fields: {
            'firstName': 'نام',
            'lastName': 'نام خانوادگی',
            'homeLocationText': 'آدرس',
            'postalCode': 'کد پستی',
            'userName': 'نام کاربری',
            'cellPhoneNumber': 'تلفن همراه',
            'homePhoneNumber': 'تلفن ثابت',
          }
        },
        activeUser: null,
        activeUserTasks: [],
        selected: [],
        selectedCohorts: [],
        userCohortsVisible: false,
        userTasksVisible: false,
        cohortsFilter: this.$store.state.cohort ? [this.$store.state.cohort.id] : [],
        statuses: [
          {name: 'همه', value: ''},
          {name: 'قفل شده', value: "1"},
          {name: 'قفل نشده', value: "0"},
        ],
        statusFilter: '',
      }
    },
    mounted() {
      if (!this.students.length)
        this.$store.dispatch('fetchStudents')
      if (!this.tasks.length)
        this.$store.dispatch('fetchTasks')

      if (!this.cohorts.length)
        this.$store.dispatch('fetchCohorts')
      if (this.$store.state.cohort) {
        this.$store.commit('SET_STATE', {cohort: null})
      }
    },
    methods: {
      getDeviceInfo(deviceId, key) {
        const device = this.$store.state.devices.find(i => i.id == deviceId)
        if (device)
          return device[key]
        return ''
      },
      deleteStudent(id) {
        if (confirm("آیا اطمینان دارید؟")) {
          this.activeUser = this.students.find(i => i.id === id)
          let studentTasks = [];
          this.tasks.forEach(task => {
            task.members.filter(i => i.id === id).forEach(m => {
              studentTasks.push({id: task.id, name: task.name})
            })
          })
          if (studentTasks.length) {
            this.activeUserTasks = studentTasks;
            this.userTasksVisible = true
          } else {
            this.$store.dispatch('deleteStudent', {
              id: id
            })
          }
        }
      },
      sendMessage(user) {
        this.$store.commit('USERS_WHO_NEED_MSG_CHANGED', {
          action: 'update',
          users: [user]
        })
        this.sendMessageVisible = true
      },
      addUsersToCohorts() {
        let groups = this.selectedCohorts.map(i => {
          return {groupId: i}
        })
        let payload = []
        this.selected.map(i => i.id).forEach((selectedUserId, index) => {
          const userGroupsIds = this.students.find(i => i.id === selectedUserId).groups.map(i => i.id)
          const allowedGroups = groups.filter(i => !userGroupsIds.includes(i.groupId))
          if (allowedGroups.length) {
            payload.push({
              "userId": selectedUserId,
              "groups": allowedGroups
            })
          }
          //after foreach processed
          if (index === this.selected.length - 1) {
            if (payload.length) {
              this.$store.dispatch('addUsersToCohorts', {payload: payload, context: 'students'}).then(res => {
                this.$vs.notify({
                  title: 'با موفقیت انجام شد', text: '', color: 'success', position: 'top-center'
                })
                this.selected = []
                this.selectedCohorts = []
              })
            } else {
              this.selectedCohorts = []
              this.selected = []
            }
          }
        });

      },
      showUserCohorts(userId) {
        this.activeUser = this.students.find(i => i.id === userId)
        this.userCohortsVisible = true
      },
      removeUserFromCohort(userId, cohortId) {
        this.$store.dispatch('removeUserFromCohort', {
          userId: userId,
          groupId: cohortId,
          role: 'student'
        }).then(res => {
          // this.userCohortsVisible = false
        })
      },
      removeUserFromTask(userId, taskId) {
        this.$store.dispatch('deleteTaskMember', {
          taskId: taskId,
          userId: userId,
        }).then(() => {
          this.activeUserTasks = this.activeUserTasks.filter(i => i.id !== taskId)
          if (!this.activeUserTasks.length)
            this.userTasksVisible = false
        })
      },
      removeCohortFilter(cohortId) {
        this.cohortsFilter = this.cohortsFilter.filter(i => i !== cohortId)
      },
      resetFilter() {
        this.cohortsFilter = []
        this.statusFilter = ''
        this.$store.commit('SET_STATE', {cohort: null})
      },
      lockProfile(user) {
        this.$store.dispatch('changeUserLock', {
          userIds: [user.id],
          lock: Number(!user.locked),
          role: 'student'
        })
      }
    },
    computed: {
      students() {
        let users = Object.assign([], this.$store.state.students);
        if (this.cohortsFilter.length) {
          users = users.filter(student => {
            const userGroupsIds = student.groups.map(x => x.id)
            return this.cohortsFilter.every(cohortFilterId => userGroupsIds.includes(cohortFilterId))
          })
        }
        if (this.statusFilter !== '') {
          users = users.filter(u => {
            return u.locked == this.statusFilter
          })
        }
        return users;
      },
      cohorts() {
        return this.$store.state.cohorts;
      },
      tasks() {
        return this.$store.state.tasks;
      },

    }
  }
</script>


<style>

  .text-muted {
    color: #a4a4a4;
  }

  .avatar .avatar-status-online {
    background-color: #dcdcdc;
  }

  .avatar .avatar-status-offline {
    background-color: #FF2643;
  }

  .avatar [class*='avatar-status-'] {
    border-radius: 50%;
    width: 11px;
    height: 11px;
    position: absolute;
    left: 0;
    bottom: 0;
    border: 1px solid #FFFFFF;
  }

  .avatar {
    white-space: nowrap;
    border-radius: 50%;
    position: relative;
    cursor: pointer;
    color: #FFFFFF;
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-size: 0.75rem;
    text-align: center;
    vertical-align: middle;
    margin: 5px;
  }

  .cohorts-number {
    padding: 3px;
    min-width: 30px;
    background-color: #eaeaea;
    border: none;
    border-radius: 3px;
    cursor: pointer;
  }

  .user-cohort-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 5px;
    margin-bottom: 5px;
    border-bottom: #d6d6d6 1px solid;
  }

</style>
